// /* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React from "react";
import Container from "@mui/material/Container";
import { DataGrid } from "@mui/x-data-grid";
import Axios from "axios";
import { useState, useEffect, useRef } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
// import UploadIcon from '@mui/icons-material/Upload';
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx/xlsx.mjs";
// import excelFile from '../fileuploadregister/datastu.xlsx';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70vw",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#87EA84"),
  backgroundColor: "#87EA84",
  "&:hover": {
    backgroundColor: "#00D3AD",
  },
}));

const COURSE_NAME_TO_ID = {
  การทัพอากาศ: "011",
  เสนาธิการทหารอากาศ: "021",
  นายทหารอากาศอาวุโส: "031",
  // หลักสูตรนายทหารชั้นผู้บังคับฝูง ใช้ 141 (4 หมวดวิชา) เป็นค่าเริ่มต้น; 041 (5 หมวด) ใช้เมื่อระบุใน Excel ชัดเจน
  นายทหารชั้นผู้บังคับฝูง: "141",
  "นายทหารชั้นผู้บังคับฝูง (5 หมวดวิชา)": "041",
  "นายทหารชั้นผู้บังคับฝูง (หลักสูตรใหม่ 4 หมวด)": "141",
  "นายทหารชั้นผู้บังคับฝูง (4 หมวดวิชา)": "141",
  นายทหารชั้นผู้บังคับหมวด: "051",
  นายทหารประทวนเป็นนายทหารสัญญาบัตร: "052",
  นายทหารประทวน: "061",
  นายทหารประทวนชั้นพันจ่าอากาศอาวุโส: "062",
  ครูทหารชั้นสัญญาบัตร: "071",
  ครูทหารชั้นประทวน: "072",
  ครูการบินเพื่อฝึกศิษย์การบิน: "073",
  ผู้ทำหน้าที่ปกครองชั้นสัญญาบัตร: "074",
  ผู้ทำหน้าที่ปกครองชั้นประทวน: "075",
  "ภาษาอังกฤษสำหรับเสมียน สน.ผชท.ไทย/ต่างประเทศ": "082",
  ภาษาไทยสำหรับนายทหารต่างประเทศ: "083",
  นายทหารการศึกษาและการฝึก: "091",
  เจ้าหน้าที่การศึกษาและการฝึก: "092",
};

const resolveCourseId = (rawCourseValue) => {
  const value = String(rawCourseValue || "").trim();
  if (/^\d{3}$/.test(value)) return value;
  return COURSE_NAME_TO_ID[value] || "";
};

/** ดึงรหัสหลักสูตรจาก AccessRights รองรับทั้ง 041 และ 141 (หลักสูตรนายทหารชั้นผู้บังคับฝูง) */
const getCourseIdFromAccessRights = (accessRights) => {
  const raw = String(accessRights || "").trim();
  if (raw.indexOf("-") !== -1) {
    const part = raw.split("-")[1];
    if (part && /^\d{3}$/.test(part.trim())) return part.trim();
  }
  if (raw.length >= 14) {
    const three = raw.substring(11, 14);
    if (/^\d{3}$/.test(three)) return three;
  }
  return "";
};

export default function PageManage() {
  //-----------กรรมวิธี
  //เจ้าหน้าที่
  const columns = [
    {
      field: "id",
      headerAlign: "center",
      headerName: "ลำดับ",
      width: 60,
      valueGetter: (params) => params.api.getRowIndex(params.row.PerId) + 1,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PerId",
      headerAlign: "center",
      headerName: "เลขประจำตัว",
      width: 130,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Fullname",
      headerAlign: "center",
      headerName: "ยศ ชื่อ สกุล",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "left",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Approve",
      headerAlign: "center",
      headerName: "เข้าถึงสถานศึกษา",
      align: "center",
      width: 140,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 100 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Approve === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                ApprovehandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "EvaluationCenter",
      headerAlign: "center",
      headerName: "สิทธิ์วัดผลส่วนกลาง",
      align: "center",
      width: 140,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 100 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.EvaluationCenter === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                EvaluationCenterhandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "ProcessCenter",
      headerAlign: "center",
      headerName: "สิทธิ์กรรมวิธีส่วนกลาง",
      align: "center",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 100 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.ProcessCenter === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                ProcessCenterhandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "Director",
      headerAlign: "center",
      headerName: "สิทธิ์ผอ.",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 110 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Director === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                DirectorhandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "Process",
      headerAlign: "center",
      headerName: "สิทธิ์กรรมวิธี",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 110 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Process === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                ProcesshandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "Evaluation",
      headerAlign: "center",
      headerName: "สิทธิ์วัดผล",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 110 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Evaluation === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                EvaluationhandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "Administrative",
      headerAlign: "center",
      headerName: "สิทธิ์ปกครอง",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 110 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Administrative === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                AdministrativehandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "Professor",
      headerAlign: "center",
      headerName: "สิทธิ์อาจารย์",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 110 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Professor === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                ProfessorhandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "Student",
      headerAlign: "center",
      headerName: "สิทธิ์นทน.",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Student === 1 ? "--มีสิทธิ์--" : "--ไม่มีสิทธิ์--"}
          </div>
        );
      },
    },
    {
      field: "AcctStatus",
      headerAlign: "center",
      headerName: "สถานะบัญชี",
      width: 120,
      renderCell: (cellValues) => {
        const AcctStatushandleChange = (event, data) => {
          const checked = event.target.checked;
          const AccessRightsId = data;

          const value = {
            AccessRightsId: AccessRightsId,
            checked: checked,
          };
          // console.log('value จนท: ', value)

          Axios.put(
            process.env.REACT_APP_API + `/AcctStatus?token=${token1}`,
            value
          )
            .then((res) => {
              toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
            })
            .catch((err) => {
              if (err.response.status === 400) {
                toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
                localStorage.clear();
                navigate("/");
              } else {
                console.log("err: ", err.response.data);
              }
              console.log(err.response);
            });
        };
        return (
          <>
            <Switch
              onChange={(event) =>
                AcctStatushandleChange(event, cellValues.row.AccessRightsId)
              }
              checked={cellValues.row.AcctStatus === "ปกติ" ? true : false}
            />
            {cellValues.row.AcctStatus === "ปกติ" ? "ปกติ" : "ถูกระงับ"}
          </>
        );
      },
    },
  ];
  //นทน.
  const columns1 = [
    {
      field: "id",
      headerAlign: "center",
      headerName: "ลำดับ",
      width: 100,
      valueGetter: (params) => params.api.getRowIndex(params.row.PerId) + 1,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PerId",
      headerAlign: "center",
      headerName: "เลขประจำตัว",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Fullname",
      headerAlign: "center",
      headerName: "ยศ ชื่อ สกุล",
      width: 300,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "left",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Approve",
      headerAlign: "center",
      headerName: "เข้าถึงสถานศึกษา",
      align: "center",
      width: 140,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 100 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Approve === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                ApprovehandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },
    {
      field: "Student",
      headerAlign: "center",
      headerName: "สิทธิ์ นทน.",
      align: "center",
      width: 210,
      renderCell: (cellValues) => {
        return (
          <FormControl sx={{ minWidth: 100 }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              size="small"
              align="center"
              defaultValue={
                cellValues.row.Student === 1 ? "อนุมัติ" : "ไม่อนุมัติ"
              }
              onChange={(event) => {
                StudenthandleChange(event, cellValues);
              }}
            >
              <MenuItem value={"อนุมัติ"}>อนุมัติ</MenuItem>
              <MenuItem value={"ไม่อนุมัติ"}>ไม่อนุมัติ</MenuItem>
            </Select>
          </FormControl>
        );
      },
    },

    {
      field: "AcctStatus",
      headerAlign: "center",
      headerName: "สถานะบัญชี",
      width: 120,
      renderCell: (cellValues) => {
        const AcctStatushandleChange = (event, data) => {
          const checked = event.target.checked;
          const AccessRightsId = data;

          const value = {
            AccessRightsId: AccessRightsId,
            checked: checked,
          };
          // console.log("value: ",value);
          // console.log("AcctStatus: ",cellValues.row.AcctStatus);

          Axios.put(
            process.env.REACT_APP_API + `/AcctStatus?token=${token1}`,
            value
          )
            .then((res) => {
              toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
            })
            .catch((err) => {
              if (err.response.status === 400) {
                toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
                localStorage.clear();
                navigate("/");
              } else {
                console.log("err: ", err.response.data);
              }
              console.log(err.response);
            });
        };
        return (
          <>
            <Switch
              onChange={(event) =>
                AcctStatushandleChange(event, cellValues.row.AccessRightsId)
              }
              checked={cellValues.row.AcctStatus === "ปกติ" ? true : false}
              // checked = {false}
            />
            {cellValues.row.AcctStatus === "ปกติ" ? "ปกติ" : "ถูกระงับ"}
          </>
        );
      },
    },
  ];
  //--------ของส่วนกลาง
  //เจ้าหน้าที่
  const columns2 = [
    {
      field: "id",
      headerAlign: "center",
      headerName: "ลำดับ",
      width: 60,
      valueGetter: (params) => params.api.getRowIndex(params.row.PerId) + 1,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PerId",
      headerAlign: "center",
      headerName: "เลขประจำตัว",
      width: 130,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Fullname",
      headerAlign: "center",
      headerName: "ยศ ชื่อ สกุล",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "left",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Approve",
      headerAlign: "center",
      headerName: "เข้าถึงสถานศึกษา",
      align: "center",
      width: 140,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Approve === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "EvaluationCenter",
      headerAlign: "center",
      headerName: "สิทธิ์วัดผลส่วนกลาง",
      align: "center",
      width: 140,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.EvaluationCenter === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "ProcessCenter",
      headerAlign: "center",
      headerName: "สิทธิ์กรรมวิธีส่วนกลาง",
      align: "center",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.ProcessCenter === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "Director",
      headerAlign: "center",
      headerName: "สิทธิ์ผอ.",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Director === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "Process",
      headerAlign: "center",
      headerName: "สิทธิ์กรรมวิธี",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Process === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "Evaluation",
      headerAlign: "center",
      headerName: "สิทธิ์วัดผล",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Evaluation === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "Administrative",
      headerAlign: "center",
      headerName: "สิทธิ์ปกครอง",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Administrative === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "Professor",
      headerAlign: "center",
      headerName: "สิทธิ์อาจารย์",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Professor === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "Student",
      headerAlign: "center",
      headerName: "สิทธิ์นทน.",
      align: "center",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Student === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "AcctStatus",
      headerAlign: "center",
      headerName: "สถานะบัญชี",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.AcctStatus === "ปกติ" ? "ปกติ" : "ถูกระงับ"}
          </div>
        );
      },
    },
  ];
  //นทน.
  const columns3 = [
    {
      field: "id",
      headerAlign: "center",
      headerName: "ลำดับ",
      width: 100,
      valueGetter: (params) => params.api.getRowIndex(params.row.PerId) + 1,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "PerId",
      headerAlign: "center",
      headerName: "เลขประจำตัว",
      width: 200,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Fullname",
      headerAlign: "center",
      headerName: "ยศ ชื่อ สกุล",
      width: 300,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "left",
            }}
          >
            {cellValues.value}
          </div>
        );
      },
    },
    {
      field: "Approve",
      headerAlign: "center",
      headerName: "เข้าถึงสถานศึกษา",
      align: "center",
      width: 140,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Approve === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },
    {
      field: "Student",
      headerAlign: "center",
      headerName: "สิทธิ์ นทน.",
      align: "center",
      width: 210,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.Student === 1 ? "มีสิทธิ์" : "ไม่มีสิทธิ์"}
          </div>
        );
      },
    },

    {
      field: "AcctStatus",
      headerAlign: "center",
      headerName: "สถานะบัญชี",
      width: 120,
      renderCell: (cellValues) => {
        return (
          <div
            style={{
              width: "100%",
              textAlign: "center",
              color: "#778899",
            }}
          >
            {cellValues.row.AcctStatus === "ปกติ" ? "ปกติ" : "ถูกระงับ"}
          </div>
        );
      },
    },
  ];
  const [opens, setOpens] = React.useState(false);
  const [openss, setOpenss] = React.useState(false);
  const [opensss, setOpensss] = React.useState(false);
  const [getUser, setGetUser] = useState([]);
  const [getAccessRightsId, setGetAccessRightsId] = useState([]);
  const [getUserstu, setGetUserstu] = useState([]);
  const AccessRights = localStorage.getItem("AccessRights") || "";
  const CourseName = localStorage.getItem("CourseName");
  // รองรับทั้งหลักสูตร 041 (5 หมวด) และ 141 (4 หมวดวิชา) - ดึง course id จากรูปแบบ "PersId-CourseId-CourseGrp"
  const Id = getCourseIdFromAccessRights(AccessRights);
  const checkStatus = localStorage.getItem("Access");
  const token1 = localStorage.getItem("token");
  const token = JSON.parse(localStorage.getItem("token"));
  const [getTbcourseyear, setTbcourseyear] = useState([]);
  const [alerts, setAlerts] = useState(false);
  const [user, setUser] = useState([]);
  const [DataNotSame, setDataNotSame] = useState([]);
  const [DataSame, setDataSame] = useState([]);
  const [folderName, setFolderName] = useState("");
  const navigate = useNavigate();
  const toastid = useRef(null); //progress bar in toastify

  useEffect(() => {
    Axios.get(process.env.REACT_APP_API + `/Gettbcourseyear?token=${token}`)
      .then((res) => {
        setTbcourseyear(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Axios.get(process.env.REACT_APP_API + `/GetAccessRightsId?token=${token}`)
      .then((res) => {
        setGetAccessRightsId(res.data);
      })
      .catch((err) => {
        if (err.response.status === 400) {
          // toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // formstudent
  const fileData = {};
  const processExcelFile = (data) => {
    var workbook = XLSX.read(data, { type: "binary" });
    const wsname = workbook.SheetNames[0];
    const ws = workbook.Sheets[wsname];
    const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
    // console.log(dataParse.slice(1))
    const UserExcel = dataParse.slice(1);
    // console.log("UserExcel",UserExcel)
    // var AllSheetNames = workbook.SheetNames;
    // debugger
    const dataCourseGrp = [];
    const dataCourseYear = [];
    const dataCourseName = [];
    const dataStudentId = [];
    const dataSeminar = [];
    const dataPersId = [];
    const dataRank = [];
    const dataPersFname = [];
    const dataPersLname = [];
    const dataPersWeight = [];
    const dataPersHeight = [];
    const dataPersCorps = [];
    const dataPersGrp = [];
    const dataPersDutyNum = [];
    const dataPersCurrPosition = [];
    const dataPersAffiliation = [];
    const dataemail = [];
    const dataNamefile = [];
    const dataNamefileNo = [];
    const AccessRightsIds = [];
    const PersIdrepeated = [];
    const CourseYearIdIntbxxx = [];

    const nonUniqueNames = UserExcel.reduce((acc, item) => {
      if (
        UserExcel.filter((i) => i[5] === item[5]).length > 1 &&
        !acc.includes(item[5])
      ) {
        acc.push(item[5]);
      }
      return acc;
    }, []);
    if (nonUniqueNames.length > 0) {
      setAlerts(true);
      toast.error(
        `ไฟล์มีเลขประจำตัวข้าราชการที่ซ้ำคือ ${nonUniqueNames.join(
          ", "
        )} กรุณาอัพโหลดเอกสารใหม่`
      );
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    }
    // console.log("nonUniqueNames",nonUniqueNames)

    for (let i = 0; i < UserExcel.length; i++) {
      const item = UserExcel[i];
      const CourseGrp = item[0];
      const CourseYear = item[1];
      const CourseName = item[2];
      const StudentId = item[3];
      const Seminar = item[4];
      const PersId = item[5];
      const Rank = item[6];
      const PersFname = item[7];
      const PersLname = item[8];
      const PersWeight = item[9];
      const PersHeight = item[10];
      const PersCorps = item[11];
      const PersGrp = item[12];
      const PersDutyNum = item[13];
      const PersCurrPosition = item[14];
      const PersAffiliation = item[15];
      const email = item[16];
      const Namefile = item[17] === undefined ? "no" : item[17];
      const AccessRightsId = PersId + "-" + Id;
      const CourseId = resolveCourseId(CourseName);
      const CourseYearIdIntb = CourseId + "-" + CourseGrp + "-" + PersId;


      // CourseYearIdIntbxxx.push(CourseYearIdIntb)
      PersIdrepeated.push(PersId);

      AccessRightsIds.push(AccessRightsId);

      CourseYearIdIntbxxx.push(CourseYearIdIntb);

      // const findP = PersId.filter((persid)=>{return persid.length <= 9})
      // console.log("findP: ",findP)
      // console.log("PersId: ",PersId)

      // console.log("ID length: ",PersId.length)
      // console.log("ID length: ",PersId)
      // console.log("CourseYearIdIntbxxx: ",CourseYearIdIntbxxx)
      if (CourseGrp === undefined) {
        dataCourseGrp.push(CourseGrp);
      } else if (CourseYear === undefined) {
        dataCourseYear.push(CourseYear);
      } else if (CourseName === undefined || CourseId === "") {
        dataCourseName.push(CourseName);
      } else if (StudentId === undefined) {
        dataStudentId.push(StudentId);
      } else if (Seminar === undefined) {
        dataSeminar.push(Seminar);
      } else if (PersId === undefined) {
        dataPersId.push(PersId);
      } else if (Rank === undefined) {
        dataRank.push(Rank);
      } else if (PersFname === undefined) {
        dataPersFname.push(PersFname);
      } else if (PersLname === undefined) {
        dataPersLname.push(PersLname);
      } else if (PersWeight === undefined) {
        dataPersWeight.push(PersWeight);
      } else if (PersHeight === undefined) {
        dataPersHeight.push(PersHeight);
      } else if (PersCorps === undefined) {
        dataPersCorps.push(PersCorps);
      } else if (PersGrp === undefined) {
        dataPersGrp.push(PersGrp);
      } else if (PersDutyNum === undefined) {
        dataPersDutyNum.push(PersDutyNum);
      } else if (PersCurrPosition === undefined) {
        dataPersCurrPosition.push(PersCurrPosition);
      } else if (PersAffiliation === undefined) {
        dataPersAffiliation.push(PersAffiliation);
      } else if (email === undefined) {
        dataemail.push(email);
      } else if (Namefile !== "no") {
        dataNamefileNo.push(Namefile);
      }
      // else{
      //   console.log("test")
      // }
    }

    const MapAccessRightsIds = AccessRightsIds.map((getAccesss) => getAccesss);

    const MapgetAccessRightsId = getAccessRightsId.map(
      (getAccess) => getAccess.AccessRightsId
    );

    const FilterAccessRightsIds = MapgetAccessRightsId.filter(
      (FilterAccessRightsId) =>
        MapAccessRightsIds.includes(FilterAccessRightsId)
    );

    const MapCourseyearsIds = CourseYearIdIntbxxx.map(
      (getCourseyearsss) => getCourseyearsss
    );

    const MapgetCourseyearsId = getTbcourseyear.map(
      (getAccess) => getAccess.CourseYearId
    );

    const FilterCourseyearsIds = MapgetCourseyearsId.filter(
      (FilterCourseyearsId) => MapCourseyearsIds.includes(FilterCourseyearsId)
    );
    // console.log("FilterCourseyearsIds",FilterCourseyearsIds.length)

    // console.log("FilterCourseyearsIds: ", FilterCourseyearsIds)

    const FilterDataNamefileNo = dataNamefileNo.map((fileNo) =>
      fileNo.substring(fileNo.length - 3)
    );
    for (let i = 0; i < FilterDataNamefileNo.length; i++) {
      const itemFile = FilterDataNamefileNo[i];
      itemFile !== "jpg" && itemFile !== "png"
        ? dataNamefile.push(itemFile)
        : console.log("");
    }
    const dataArrPersId = [];
    const dataArrCourseName = [];
    const CourseName = localStorage.getItem("CourseName");
    for (let i = 0; i < UserExcel.length; i++) {
      const item = UserExcel[i][5];
      const itemcoursename = UserExcel[i][2];
      dataArrPersId.push(String(item));
      dataArrCourseName.push(String(itemcoursename));
    }
    const findP = dataArrPersId.filter((persid) => {
      return persid.length !== 10;
    });
    const findC = dataArrCourseName.filter((courseInExcel) => {
      return resolveCourseId(courseInExcel) !== Id;
    });
    //  console.log("find: ", findC)
    //  console.log("findP: ", findP)
    if (findP.length > 0) {
      setAlerts(true);
      toast.error("กรุณาตรวจสอบเลขประจำตัว นทน. ในฟอร์ม Excel");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (
      FilterCourseyearsIds.length > 0 &&
      FilterAccessRightsIds.length > 0
    ) {
      setAlerts(true);
      toast.error("มีสมาชิกอยู่ในระบบเรียบร้อยแล้ว");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataCourseGrp.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่เลขรุ่นในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataCourseYear.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ปีการศึกษาในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataCourseName.length > 0 || findC.length > 0) {
      setAlerts(true);
      toast.error("กรุณาตรวจสอบรหัสหลักสูตร/ชื่อหลักสูตรในฟอร์ม Excel");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataStudentId.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่รหัสนักเรียนในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataSeminar.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่กลุ่มสัมมนาในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataRank.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ยศในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersFname.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ชื่อในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersLname.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่นามสกุลในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersWeight.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่น้ำหนักในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersHeight.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ส่วนสูงในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersCorps.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่เหล่าในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersGrp.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่จำพวกในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersDutyNum.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ลชทอในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersCurrPosition.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ตำแหน่งในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersAffiliation.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่สังกัดในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataemail.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่อีเมล ทอ.ในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (FilterAccessRightsIds.length > 0) {
      // console.log("Test")
      submittbcourseyear(FilterAccessRightsIds, dataParse);
    } else if (dataNamefile.length > 0) {
      // console.log("dataNamefile: ",dataNamefile)
      setAlerts(true);
      toast.error("ไฟล์ที่ upload ไม่ใช่นามสกุล .png หรือ .jpg");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else {
      setUser(dataParse);
    }
  };

  const fileSelected = (event) => {
    var files = event.target.files,
      f = files[0];
    fileData["fileName"] = files[0].name;

    if (typeof FileReader != "undefined") {
      var reader = new FileReader();

      if (reader.readAsBinaryString) {
        reader.onload = function (e) {
          processExcelFile(e.target.result);
        };
      }
    } else {
      reader.onload = function (e) {
        var data = "";
        var bytes = new Uint8Array(e.target.result);
        for (var i = 0; i < bytes.byteLength; i++) {
          data += String.fromCharCode(bytes[i]);
        }
        processExcelFile(data);
      };
    }
    reader.readAsBinaryString(f);
    // console.log({files})
  };

  const submit = () => {
    // console.log(DataSame.length >= 1 && DataNotSame.length >= 1)
    if (user.length >= 1) {
      setAlerts(true);
      // toast.success("อัพโลหข้อมูลเรียบร้อย")
      Axios.post(
        process.env.REACT_APP_API + `/RegisStuFileExel/${Id}?token=${token1}`,
        {
          UserExcel: user,
        }
      )
        .then((res) => {
          setUser([
            ...user,
            {
              UserExcel: user,
              Id: Id,
            },
          ]);
          toast.success(res.data.msg);
          refreshStudentList();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
            localStorage.clear();
            navigate("/");
          } else {
            console.log("err: ", err.response.data);
          }
        });
      setTimeout(() => {
        handleCloses();
        handleClose();
      }, 1000);
    } else if (DataSame.length >= 1 && DataNotSame.length >= 1) {
      setAlerts(true);
      toast.success("อัพโหลดข้อมูลเรียบร้อย");
      Promise.all([
        Axios.post(
          process.env.REACT_APP_API + `/Posttbcourseyear/?token=${token1}`,
          { DataSame: DataSame }
        ),
        Axios.post(
          process.env.REACT_APP_API + `/Posttbaccessrights/?token=${token1}`,
          { DataNotSame: DataNotSame }
        ),
      ])
        .then(() => {
          setDataSame([...DataSame, { DataSame: DataSame }]);
          setDataNotSame([...DataNotSame, { DataNotSame: DataNotSame }]);
          refreshStaffList();
          refreshStudentList();
        })
        .catch((err) => {
          if (err.response?.status === 400) {
            toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
            localStorage.clear();
            navigate("/");
          } else {
            console.log("err: ", err.response?.data);
          }
        });
      setTimeout(() => {
        handleCloses();
        handleClose();
      }, 1000);
    }
  };

  const submittbcourseyear = (FilterAccessRightsIds, b) => {
    const data = [];
    const Usertbcourseyear = b.slice(1);

    for (let i = 0; i < Usertbcourseyear.length; i++) {
      const item = Usertbcourseyear[i];
      const AccessRightsId = item[5] + "-" + Id;
      data.push(AccessRightsId);
    }
    // Ensure Usertbcourseyear has at least 17 elements in each sub-array
    if (Usertbcourseyear.some((arr) => arr.length < 17)) {
      // console.log("Error: Each sub-array in Usertbcourseyear must have at least 17 elements.");
    } else {
      // Loop through the arrays and perform the merging
      for (let i = 0; i < Usertbcourseyear.length; i++) {
        // Assuming you have 3 elements in data array (data[0], data[1], data[2])
        let dataToMerge = data[i];
        let indexToMerge = 16; // The index in Usertbcourseyear where dataToMerge will be merged

        // Perform the merge operation by using splice to insert dataToMerge into Usertbcourseyear
        Usertbcourseyear[i].splice(indexToMerge + 1, 0, dataToMerge);
      }
    }

    // Function to find identical entries in array2 across all sub-arrays at index 17
    function findIdenticalEntries(array1, array2) {
      let identicalEntries = [];
      let notIdenticalEntries = [];

      for (let i = 0; i < array1.length; i++) {
        let currentArray1 = array1[i];
        for (let k = 0; k < array2.length; k++) {
          let currentArray2 = array2[k][17];
          if (
            currentArray2.includes(currentArray1) &&
            !identicalEntries.includes(array2[k])
          ) {
            identicalEntries.push(array2[k]);
          }
        }
      }
      notIdenticalEntries = array2.filter(
        (item) => !identicalEntries.includes(item)
      );
      return { identicalEntries, notIdenticalEntries };
    }

    let { identicalEntries, notIdenticalEntries } = findIdenticalEntries(
      FilterAccessRightsIds,
      Usertbcourseyear
    );
    const dataToSend = {
      DataSame: identicalEntries,
      DataNotSame: notIdenticalEntries,
    };
    setDataNotSame(dataToSend.DataNotSame);
    setDataSame(dataToSend.DataSame);
  };

  // formstudentforeign
  const fileDataforeign = {};
  const processExcelFileforeign = (data) => {
    var workbook = XLSX.read(data, { type: "binary" });
    const wsname = workbook.SheetNames[0];
    const ws = workbook.Sheets[wsname];
    const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
    // console.log(dataParse.slice(1))
    const UserExcel = dataParse.slice(1);
    // console.log(dataParse)
    // console.log(UserExcel[249][17].substring(UserExcel[249][17].length - 3))
    // var AllSheetNames = workbook.SheetNames;
    // debugger
    const dataCourseGrp = [];
    const dataCourseYear = [];
    const dataCourseName = [];
    const dataStudentId = [];
    const dataSeminar = [];
    const dataPersId = [];
    const dataRank = [];
    const dataPersFname = [];
    const dataPersLname = [];
    const dataPersWeight = [];
    const dataPersHeight = [];
    const dataPersCorps = [];
    const dataPersGrp = [];
    const dataPersDutyNum = [];
    const dataPersCurrPosition = [];
    const dataPersAffiliation = [];
    const dataemail = [];
    const datapassword = [];
    const dataNamefile = [];
    const dataNamefileNo = [];
    const AccessRightsIds = [];
    const dataNamefileNoname = [];
    const CourseYearIdIntbxxx = [];

    const nonUniqueNames = UserExcel.reduce((acc, item) => {
      if (
        UserExcel.filter((i) => i[5] === item[5]).length > 1 &&
        !acc.includes(item[5])
      ) {
        acc.push(item[5]);
      }
      return acc;
    }, []);
    if (nonUniqueNames.length > 0) {
      setAlerts(true);
      toast.error(
        `ไฟล์มีเลขประจำตัวข้าราชการที่ซ้ำคือ ${nonUniqueNames.join(
          ", "
        )} กรุณาอัพโหลดเอกสารใหม่`
      );
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else {
      console.log("");
    }

    for (let i = 0; i < UserExcel.length; i++) {
      const item = UserExcel[i];
      const CourseGrp = item[0];
      const CourseYear = item[1];
      const CourseName = item[2];
      const StudentId = item[3];
      const Seminar = item[4];
      const PersId = item[5];
      const Rank = item[6];
      const PersFname = item[7];
      const PersLname = item[8];
      const PersWeight = item[9];
      const PersHeight = item[10];
      const PersCorps = item[11];
      const PersGrp = item[12];
      const PersDutyNum = item[13];
      const PersCurrPosition = item[14];
      const PersAffiliation = item[15];
      const email = item[16];
      const password = item[17];
      const Namefile = item[18] === undefined ? "no" : item[18];
      const NamefileNoname = item[18];
      const CourseId = resolveCourseId(CourseName);
      const AccessRightsId = PersId + "-" + Id;
      const CourseYearIdIntb = CourseId + "-" + CourseGrp + "-" + PersId;
      //  console.log(Namefile.substring(Namefile.length - 3))
      AccessRightsIds.push(AccessRightsId);
      CourseYearIdIntbxxx.push(CourseYearIdIntb);
      // const findP = PersId.filter((persid)=>{return persid.length <= 9})
      // console.log("findP: ",findP)
      // console.log("PersId: ",PersId)

      // console.log("ID length: ",PersId.length)
      // console.log("ID length: ",PersId)
      // console.log("UserExcel length: ",UserExcel)
      if (CourseGrp === undefined) {
        dataCourseGrp.push(CourseGrp);
      } else if (CourseYear === undefined) {
        dataCourseYear.push(CourseYear);
      } else if (CourseName === undefined || CourseId === "") {
        dataCourseName.push(CourseName);
      } else if (StudentId === undefined) {
        dataStudentId.push(StudentId);
      } else if (Seminar === undefined) {
        dataSeminar.push(Seminar);
      } else if (PersId === undefined) {
        dataPersId.push(PersId);
      } else if (Rank === undefined) {
        dataRank.push(Rank);
      } else if (PersFname === undefined) {
        dataPersFname.push(PersFname);
      } else if (PersLname === undefined) {
        dataPersLname.push(PersLname);
      } else if (PersWeight === undefined) {
        dataPersWeight.push(PersWeight);
      } else if (PersHeight === undefined) {
        dataPersHeight.push(PersHeight);
      } else if (PersCorps === undefined) {
        dataPersCorps.push(PersCorps);
      } else if (PersGrp === undefined) {
        dataPersGrp.push(PersGrp);
      } else if (PersDutyNum === undefined) {
        dataPersDutyNum.push(PersDutyNum);
      } else if (PersCurrPosition === undefined) {
        dataPersCurrPosition.push(PersCurrPosition);
      } else if (PersAffiliation === undefined) {
        dataPersAffiliation.push(PersAffiliation);
      } else if (email === undefined) {
        dataemail.push(email);
      } else if (password === undefined) {
        dataemail.push(password);
      } else if (Namefile !== "no") {
        dataNamefileNo.push(Namefile);
      } else if (NamefileNoname === undefined) {
        dataNamefileNoname.push(NamefileNoname);
      } else {
        console.log("");
      }
    }
    const MapAccessRightsIds = AccessRightsIds.map((getAccesss) => getAccesss);

    const MapgetAccessRightsId = getAccessRightsId.map(
      (getAccess) => getAccess.AccessRightsId
    );

    const FilterAccessRightsIds = MapgetAccessRightsId.filter(
      (FilterAccessRightsId) =>
        MapAccessRightsIds.includes(FilterAccessRightsId)
    );

    const MapCourseyearsIds = CourseYearIdIntbxxx.map(
      (getCourseyearsss) => getCourseyearsss
    );

    const MapgetCourseyearsId = getTbcourseyear.map(
      (getAccess) => getAccess.CourseYearId
    );

    const FilterCourseyearsIds = MapgetCourseyearsId.filter(
      (FilterCourseyearsId) => MapCourseyearsIds.includes(FilterCourseyearsId)
    );

    const FilterDataNamefileNo = dataNamefileNo.map((fileNo) =>
      fileNo.substring(fileNo.length - 3)
    );
    for (let i = 0; i < FilterDataNamefileNo.length; i++) {
      const itemFile = FilterDataNamefileNo[i];
      // console.log(itemFile !== "jpg")
      itemFile !== "jpg" && itemFile !== "png"
        ? dataNamefile.push(itemFile)
        : console.log("");
      // if(itemFile !== "jpg" || itemFile !== "png"){
      //   dataNamefile.push(itemFile)
      // }
    }
    // console.log(dataNamefile.length)
    // console.log(FilterDataNamefileNo[0] === "jpg")

    //chk persid
    const dataArrPersId = [];
    const dataArrCourseName = [];
    const CourseName = localStorage.getItem("CourseName");

    for (let i = 0; i < UserExcel.length; i++) {
      const item = UserExcel[i][5];
      const itemcoursename = UserExcel[i][2];
      dataArrPersId.push(String(item));
      dataArrCourseName.push(String(itemcoursename));
    }
    const findP = dataArrPersId.filter((persid) => {
      return persid.length !== 10;
    });
    const findC = dataArrCourseName.filter((courseInExcel) => {
      return resolveCourseId(courseInExcel) !== Id;
    });
    //  console.log("find: ", findC)
    if (findP.length > 0) {
      setAlerts(true);
      toast.error("กรุณาตรวจสอบเลขประจำตัว นทน. ในฟอร์ม Excel");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (
      FilterCourseyearsIds.length > 0 &&
      FilterAccessRightsIds.length > 0
    ) {
      setAlerts(true);
      toast.error("มีสมาชิกอยู่ในระบบเรียบร้อยแล้ว");
      setTimeout(() => {
        setOpens(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataCourseGrp.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่เลขรุ่นในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataCourseYear.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ปีการศึกษาในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataCourseName.length > 0 || findC.length > 0) {
      setAlerts(true);
      toast.error("กรุณาตรวจสอบรหัสหลักสูตร/ชื่อหลักสูตรในฟอร์ม Excel");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataStudentId.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่รหัสนักเรียนในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataSeminar.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่กลุ่มสัมมนาในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
      //  }else if(dataPersId.length > 0){
      //   setAlerts(true)
      //   toast.error('กรุณาใส่เลขประจำตัวข้าราชการในฟอร์มExcelให้ครบ')
      //   setTimeout(() => {
      //     handleCloses()
      //     // handleClose()
      //   }, 1000)
    } else if (dataRank.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ยศในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersFname.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ชื่อในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersLname.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่นามสกุลในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersWeight.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่น้ำหนักในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersHeight.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ส่วนสูงในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersCorps.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่เหล่าในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersGrp.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่จำพวกในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersDutyNum.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ลชทอในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersCurrPosition.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่ตำแหน่งในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataPersAffiliation.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่สังกัดในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataemail.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่อีเมล ทอ.ในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
      //  }else if(dataNamefileNoname.length > 0){
      //   setAlerts(true)
      //   toast.error('กรุณาใส่ชื่อรูปให้ครบ')
      //   setTimeout(() => {
      //     setOpensss(false);
      //     // handleClose()
      //   }, 1000)
    } else if (datapassword.length > 0) {
      setAlerts(true);
      toast.error("กรุณาใส่รหัสผ่าน ทอ.ในฟอร์มExcelให้ครบ");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (FilterAccessRightsIds.length > 0) {
      setAlerts(true);
      toast.error("ไฟล์ที่ upload มีข้อมูลอยู่แล้วกรุณาตรวจสอบ");
      setOpensss(false);
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else if (dataNamefile.length > 0) {
      setAlerts(true);
      toast.error("ไฟล์ที่ upload ไม่ใช่นามสกุล .png หรือ .jpg");
      setTimeout(() => {
        setOpensss(false);
        setOpen(false);
        // handleClose()
      }, 1000);
    } else {
      setUser(dataParse);
    } 
  };

  const fileSelectedforeign = (event) => {
    var files = event.target.files,
      f = files[0];
    fileDataforeign["fileName"] = files[0].name;

    if (typeof FileReader != "undefined") {
      var reader = new FileReader();

      if (reader.readAsBinaryString) {
        reader.onload = function (e) {
          processExcelFileforeign(e.target.result);
        };
      }
    } else {
      reader.onload = function (e) {
        var data = "";
        var bytes = new Uint8Array(e.target.result);
        for (var i = 0; i < bytes.byteLength; i++) {
          data += String.fromCharCode(bytes[i]);
        }
        processExcelFileforeign(data);
      };
    }
    reader.readAsBinaryString(f);
  };

  const submitforeign = () => {
    setAlerts(true);
    Axios.post(
      process.env.REACT_APP_API +
        `/RegisStuFileExelforeign/${Id}?token=${token1}`,
      {
        UserExcel: user,
      }
    )
      .then((res) => {
        setUser([
          ...user,
          {
            UserExcel: user,
            Id: Id,
          },
        ]);
        toast.success(res.data.msg);
        refreshStudentList();
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
      });
    setTimeout(() => {
      handleClosesss();
      handleClose();
      setOpen(false);
    }, 1000);
  };

  // --------------------------------------

  const handleCreateFolder = () => {
    fetch(process.env.REACT_APP_API + `/create-folder?token=${token1}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ folderName, Id, CourseName }),
    })
      .then((response) => {
        const isJson = response.headers
          .get("content-type")
          ?.includes("application/json");
        const data = isJson && response.json();
        // setAlerts(true)
        // toast.success('สร้างโฟลเดอร์เรียบร้อยแล้ว')
        // handleClosess()
        // check for error response
        if (!response.ok) {
          // get error message from body or default to response status
          const errors = (data && data.message) || response.status;
          setAlerts(true);
          toast.error("โฟลเดอร์นี้เคยถูกสร้างเรียบร้อยแล้ว");
          return Promise.reject(errors);
        } else {
          setAlerts(true);
          toast.success("สร้างโฟลเดอร์เรียบร้อยแล้ว");
          handleClosess();
          handleClose();
        }
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อสร้าง folder อีกครั้ง");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
      });
  };

  const handleClickOpens = () => {
    setOpens(true);
  };

  const handleCloses = () => {
    setOpens(false);
  };

  const handleClickOpenss = () => {
    setOpenss(true);
  };

  const handleClickOpensss = () => {
    setOpensss(true);
  };

  const handleClosesss = () => {
    setOpensss(false);
  };

  const handleClosess = () => {
    setOpenss(false);
  };

  //ปุ่มจัดการการเข้าถึงสิทธิ์เจ้าหน้าที่
  const [checkedtableinstructor, setcheckedtableinstructor] = useState(false);
  const Btncheckedtableinstructor = () => {
    setcheckedtableinstructor(!checkedtableinstructor);
    setcheckedtableStudent(false);
  };
  //ปุ่มจัดการการเข้าถึงสิทธิ์ นทน.
  const [checkedtableStudent, setcheckedtableStudent] = useState(false);
  const BtncheckedtableStudent = () => {
    setcheckedtableStudent(!checkedtableStudent);
    setcheckedtableinstructor(false);
  };

  //อัปเดตสิทธิ์วัดผล ส่วนกลาง
  const EvaluationCenterhandleChange = (event, cellValues) => {
    const EvaluationCenter = event.target.value;
    const EvaluationCenters = EvaluationCenter === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/EvaluationCenter/${AccessRightsId}/${EvaluationCenters}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์กรรมวิธี ส่วนกลาง
  const ProcessCenterhandleChange = (event, cellValues) => {
    const ProcessCenter = event.target.value;
    const ProcessCenters = ProcessCenter === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/ProcessCenter/${AccessRightsId}/${ProcessCenters}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์ผอ.
  const DirectorhandleChange = (event, cellValues) => {
    const Director = event.target.value;
    const Directors = Director === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/Director/${AccessRightsId}/${Directors}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์กรรมวิธี
  const ProcesshandleChange = (event, cellValues) => {
    const Process = event.target.value;
    const Processs = Process === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/Process/${AccessRightsId}/${Processs}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์วัดผล
  const EvaluationhandleChange = (event, cellValues) => {
    const Evaluation = event.target.value;
    const Evaluations = Evaluation === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/Evaluation/${AccessRightsId}/${Evaluations}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์ปกครอง
  const AdministrativehandleChange = (event, cellValues) => {
    const Administrative = event.target.value;
    const Administratives = Administrative === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/Administrative/${AccessRightsId}/${Administratives}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์อาจารย์ประจำหมวด
  const ProfessorhandleChange = (event, cellValues) => {
    const Professor = event.target.value;
    const Professors = Professor === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/Professor/${AccessRightsId}/${Professors}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์นทน.
  const StudenthandleChange = (event, cellValues) => {
    const Student = event.target.value;
    const Students = Student === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/Student/${AccessRightsId}/${Students}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };
  //อัปเดตสิทธิ์เข้าถึงการศึกษา
  const ApprovehandleChange = (event, cellValues) => {
    const Approve = event.target.value;
    const Approves = Approve === "อนุมัติ" ? 1 : 0;
    const AccessRightsId = cellValues.row.AccessRightsId;
    Axios.put(
      process.env.REACT_APP_API +
        `/Approve/${AccessRightsId}/${Approves}?token=${token1}`
    )
      .then((res) => {
        toast.success("ระบบได้ทำการอัพเดทสิทธิ์เรียบร้อยแล้ว");
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไขสิทธิ์");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response.data);
        }
        console.log(err.response);
      });
  };

  //เจ้าหน้าที่ - รายชื่อจนท. ภายในสถานศึกษา (รองรับหลักสูตร 041 และ 141)
  useEffect(() => {
    if (!Id) {
      setGetUser([]);
      return;
    }
    Axios.get(
      process.env.REACT_APP_API + `/PageManageUser/${Id}?token=${token}`
    )
      .then((res) => {
        setGetUser(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        setGetUser([]);
        if (err.response?.status === 400) {
          // toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response?.data);
        }
        console.error(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  // ดึงรายชื่อ นทน. (ใช้ทั้งตอนโหลดหน้าและหลัง upload สำเร็จ)
  const refreshStudentList = () => {
    if (!Id) return Promise.resolve();
    return Axios.get(
      process.env.REACT_APP_API + `/PageManageUserstu/${Id}?token=${token}`
    )
      .then((res) => {
        setGetUserstu(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        setGetUserstu([]);
        if (err.response?.status === 400) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response?.data);
        }
        console.error(err);
      });
  };

  // ดึงรายชื่อเจ้าหน้าที่ (ใช้หลัง upload กรณีมีสมาชิกอยู่ในระบบแล้ว)
  const refreshStaffList = () => {
    if (!Id) return Promise.resolve();
    return Axios.get(
      process.env.REACT_APP_API + `/PageManageUser/${Id}?token=${token}`
    )
      .then((res) => {
        setGetUser(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        setGetUser([]);
        if (err.response?.status === 400) {
          localStorage.clear();
          navigate("/");
        } else {
          console.log("err: ", err.response?.data);
        }
      });
  };

  //นทน.
  useEffect(() => {
    refreshStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [access, setAccess] = useState(localStorage.getItem("Access") || "");

  /*----------------- added on 12042023 -----------------------*/
  const btnuploadenablearr = {
    "นทน.": false,
    อาจารย์ประจำหมวดวิชา: true,
    ปกครอง: false,
    วัดผล: true,
    กรรมวิธี: true,
    "ผอ.": false,
    กรรมวิธีส่วนกลาง: true,
    วัดผลส่วนกลาง: false,
  };

  return (
    <React.Fragment>
      {alerts ? (
        <ToastContainer draggable={false} transition={Zoom} autoClose={3000} />
      ) : (
        <></>
      )}
      {checkStatus === "กรรมวิธี" ? (
        <div className="cotainerDetail">
          <b>
            <p className="HeadTextMain">จัดการสมาชิก</p>
          </b>

          {checkedtableinstructor === true ? (
            <div>
              <Button
                variant="contained"
                sx={{
                  minWidth: 100,
                  m: 1,
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 15,
                }}
                onClick={Btncheckedtableinstructor}
              >
                คลิกเพื่อจัดการการเข้าถึงสิทธิ์เจ้าหน้าที่
              </Button>

              <Button
                variant="outlined"
                sx={{
                  minWidth: 100,
                  m: 1,
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 15,
                }}
                onClick={BtncheckedtableStudent}
              >
                คลิกเพื่อจัดการการเข้าถึงสิทธิ์ นทน.
              </Button>
            </div>
          ) : checkedtableStudent === true ? (
            <div>
              <Button
                variant="outlined"
                sx={{
                  minWidth: 100,
                  m: 1,
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 15,
                }}
                onClick={Btncheckedtableinstructor}
              >
                คลิกเพื่อจัดการการเข้าถึงสิทธิ์เจ้าหน้าที่
              </Button>

              <Button
                variant="contained"
                sx={{
                  minWidth: 100,
                  m: 1,
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 15,
                }}
                onClick={BtncheckedtableStudent}
              >
                คลิกเพื่อจัดการการเข้าถึงสิทธิ์ นทน.
              </Button>
            </div>
          ) : (
            <div>
              <Button
                variant="outlined"
                sx={{
                  minWidth: 100,
                  m: 1,
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 15,
                }}
                onClick={Btncheckedtableinstructor}
              >
                คลิกเพื่อจัดการการเข้าถึงสิทธิ์เจ้าหน้าที่
              </Button>

              <Button
                variant="outlined"
                sx={{
                  minWidth: 100,
                  m: 1,
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 15,
                }}
                onClick={BtncheckedtableStudent}
              >
                คลิกเพื่อจัดการการเข้าถึงสิทธิ์ นทน.
              </Button>
            </div>
          )}
          {}

          {checkedtableinstructor === true ? (
            <Container>
              <br></br>
              <center>
                <p className="HeadTextMain">
                  จัดการการเข้าถึงสิทธิ์เจ้าหน้าที่
                </p>
              </center>

              <div style={{ height: 700, width: "100%" }}>
                <DataGrid
                  getRowId={(row) => row.PerId}
                  rows={getUser}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                />
              </div>
              <br></br>
              <center>
                <p>
                  **การให้สิทธิ์ของ นทน. ต้องสมัครสมาชิกสำหรับ นทน.
                  และสามารถอนุมัติสิทธิ์ได้ใน จัดการการเข้าถึงสิทธิ์ นทน.**
                </p>
              </center>
            </Container>
          ) : (
            ""
          )}

          {checkedtableStudent === true ? (
            <Container>
              <br></br>
              <center>
                <p className="HeadTextMain">จัดการการเข้าถึงสิทธิ์ นทน.</p>
              </center>
              <ColorButton
                sx={{
                  minWidth: 100,
                  marginBottom: "10px",
                  fontFamily: "THSarabunNew",
                  fontWeight: "bold",
                  fontSize: 15,
                }}
                onClick={handleOpen}
              >
                สำหรับอัพโหลดข้อมูล นทน.
              </ColorButton>
              {/* <ColorButton sx={{
                  minWidth: 100,
                  marginBottom:'10px',
                  marginLeft:'10px',
                  fontFamily: 'THSarabunNew',
                  fontWeight: 'bold',
                  fontSize: 15,
                }}  endIcon={<DownloadIcon />} onClick={downloadExcelFile}>ดาวน์โหลดไฟล์excel</ColorButton> */}
              &nbsp;
              {btnuploadenablearr[access] && (
                <ColorButton
                  sx={{
                    minWidth: 100,
                    marginBottom: "10px",
                    fontFamily: "THSarabunNew",
                    fontWeight: "bold",
                    fontSize: 15,
                  }}
                  onClick={async () => {
                    let FileSaver = require("file-saver");
                    const res = await Axios.get(
                      process.env.REACT_APP_API +
                        `/PageEstimate/xlsxdownload/${Id}?token=${token}`,
                      {
                        responseType: "blob",
                        onDownloadProgress: (progressEvent) => {
                          let percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                          );
                          if (toastid.current === null) {
                            toastid.current = toast(
                              `ดาวน์โหลดแบบฟอร์มเรียบร้อยแล้ว ${percentCompleted}%`,
                              {
                                position: toast.POSITION.TOP_CENTER,
                                type: toast.TYPE.INFO,
                                delay: 500,
                                onClose: () => {
                                  toastid.current = null;
                                },
                              }
                            );
                          } else {
                            setTimeout(() => {
                              toast.update(toastid.current, {
                                render: `ดาวน์โหลดแบบฟอร์มเรียบร้อยแล้ว ${percentCompleted}%`,
                                type: toast.TYPE.INFO,
                                //autoClose: 5000
                              });
                            }, 1000);
                          }
                        },
                      }
                    ).catch((err) => {
                      if (err.response.data.message) {
                        toast.error(
                          "กรุณาเข้าระบบใหม่เพื่อดาวน์โหลดแบบฟอร์มอีกครั้ง"
                        );
                        this.props.navigate("/");
                        localStorage.clear();
                      } else {
                        console.log("err: ", err.response.data);
                      }
                    });

                    if (res.data.error) {
                      console.error(res.data.error);
                    } else {
                      toast.done(toastid.current);
                    }

                    FileSaver.saveAs(
                      new Blob(
                        [
                          res.data,
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ],
                        {}
                      ),
                      `${Id}.xlsx`
                    );
                  }}
                >
                  ดาวน์โหลดฟอร์มบันทึกคะแนน
                </ColorButton>
              )}
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ textAlign: "center" }}
                    variant="h6"
                    component="h2"
                  >
                    สำหรับอัพโหลดข้อมูล นทน.
                  </Typography>
                  <Typography
                    id="modal-modal-title"
                    sx={{ textAlign: "center" }}
                    variant="subtitle1"
                    component="h2"
                  >
                    ***ขั้นตอนการอัพโหลด***
                  </Typography>
                  <Box sx={{ mt: 2, display: "flex", flexDirection: "column" }}>
                    <Typography
                      id="modal-modal-title"
                      variant="subtitle1"
                      component="h2"
                      sx={{ fontWeight: "bold" }}
                    >
                      {/* 1. อัพโหลดไฟล์ข้อมูล นทน. */}1. นายทหารนักเรียน
                      ทหารอากาศ
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "20px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        1.1 กรุณาดาวน์โหลดแบบฟอร์ม
                      </Typography>
                      <ColorButton
                        sx={{
                          minWidth: 100,
                          marginBottom: "10px",
                          marginLeft: "10px",
                          fontFamily: "THSarabunNew",
                          fontWeight: "bold",
                          fontSize: 15,
                        }}
                        endIcon={<DownloadIcon />}
                        onClick={async () => {
                          let FileSaver = require("file-saver");
                          const res = await Axios.get(
                            process.env.REACT_APP_API +
                              `/downloadformstu?token=${token}`,
                            {
                              // console.log("res:", res),
                              responseType: "blob",
                              onDownloadProgress: (progressEvent) => {
                                let percentCompleted = Math.round(
                                  (progressEvent.loaded * 100) /
                                    progressEvent.total
                                );
                                if (toastid.current === null) {
                                  handleClose();
                                  toastid.current = toast(
                                    `ดาวน์โหลดแบบฟอร์มเรียบร้อยแล้ว ${percentCompleted}%`,
                                    {
                                      position: toast.POSITION.TOP_CENTER,
                                      type: toast.TYPE.INFO,
                                      delay: 500,
                                      onClose: () => {
                                        toastid.current = null;
                                      },
                                    }
                                  );
                                } else {
                                  handleClose();
                                  setTimeout(() => {
                                    toast.update(toastid.current, {
                                      render: `ดาวน์โหลดแบบฟอร์มเรียบร้อยแล้ว ${percentCompleted}%`,
                                      type: toast.TYPE.INFO,
                                      //autoClose: 5000
                                    });
                                  }, 1000);
                                }
                              },
                            }
                          ).catch((err) => {
                            if (err.response.data.message) {
                              toast.error(
                                "กรุณาเข้าระบบใหม่เพื่อดาวน์โหลดแบบฟอร์มอีกครั้ง"
                              );
                              this.props.navigate("/");
                              localStorage.clear();
                            } else {
                              console.log("err: ", err.response.data);
                            }
                          });

                          if (res.data.error) {
                            console.error(res.data.error);
                          } else {
                            toast.done(toastid.current);
                          }

                          FileSaver.saveAs(
                            new Blob(
                              [
                                res.data,
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                              ],
                              {}
                            ),
                            `studentForm.xlsx`
                          );
                        }}
                      >
                        ดาวน์โหลดไฟล์ excel
                      </ColorButton>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "20px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        1.2 ใส่ข้อมูลลงใน From Excel ที่ Download
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "20px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        1.3 อัพโหลดไฟล์
                      </Typography>
                      <ColorButton
                        variant="contained"
                        sx={{
                          minWidth: 100,
                          m: 1,
                          fontFamily: "THSarabunNew",
                          fontWeight: "bold",
                          fontSize: 15,
                        }}
                        onClick={handleClickOpens}
                      >
                        อัพโหลดไฟล์ excel
                      </ColorButton>
                    </Box>
                    <Typography
                      id="modal-modal-title"
                      variant="subtitle1"
                      component="h2"
                      sx={{ fontWeight: "bold" }}
                    >
                      {/* 2. กรณี นทน.ต่างชาติเท่านั้น */} 2.
                      นายทหารนักเรียนต่างเหล่า และนายทหารนักเรียนต่างชาติ
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "20px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        2.1 อัพโหลดไฟล์ข้อมูล นายทหารนักเรียน
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "40px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        2.1.1 กรุณาดาวน์โหลดแบบฟอร์ม
                      </Typography>
                      <ColorButton
                        sx={{
                          minWidth: 100,
                          marginBottom: "10px",
                          marginLeft: "10px",
                          fontFamily: "THSarabunNew",
                          fontWeight: "bold",
                          fontSize: 15,
                        }}
                        endIcon={<DownloadIcon />}
                        onClick={async () => {
                          let FileSaver = require("file-saver");
                          const res = await Axios.get(
                            process.env.REACT_APP_API +
                              `/downloadformstudentforeign?token=${token}`,
                            {
                              // console.log("res:", res),
                              responseType: "blob",
                              onDownloadProgress: (progressEvent) => {
                                let percentCompleted = Math.round(
                                  (progressEvent.loaded * 100) /
                                    progressEvent.total
                                );
                                if (toastid.current === null) {
                                  handleClose();
                                  toastid.current = toast(
                                    `ดาวน์โหลดแบบฟอร์มเรียบร้อยแล้ว ${percentCompleted}%`,
                                    {
                                      position: toast.POSITION.TOP_CENTER,
                                      type: toast.TYPE.INFO,
                                      delay: 500,
                                      onClose: () => {
                                        toastid.current = null;
                                      },
                                    }
                                  );
                                } else {
                                  handleClose();
                                  setTimeout(() => {
                                    toast.update(toastid.current, {
                                      render: `ดาวน์โหลดแบบฟอร์มเรียบร้อยแล้ว ${percentCompleted}%`,
                                      type: toast.TYPE.INFO,
                                      //autoClose: 5000
                                    });
                                  }, 1000);
                                }
                              },
                            }
                          ).catch((err) => {
                            if (err.response.data.message) {
                              toast.error(
                                "กรุณาเข้าระบบใหม่เพื่อดาวน์โหลดแบบฟอร์มอีกครั้ง"
                              );
                              this.props.navigate("/");
                              localStorage.clear();
                            } else {
                              console.log("err: ", err.response.data);
                            }
                          });

                          if (res.data.error) {
                            console.error(res.data.error);
                          } else {
                            toast.done(toastid.current);
                          }

                          FileSaver.saveAs(
                            new Blob(
                              [
                                res.data,
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                              ],
                              {}
                            ),
                            `formstudentforeign.xlsx`
                          );
                        }}
                      >
                        ดาวน์โหลดไฟล์ excel
                      </ColorButton>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "40px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        2.1.2 ใส่ข้อมูลลงใน From Excel ที่ Download
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "40px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        2.1.3 อัพโหลดไฟล์
                      </Typography>
                      <ColorButton
                        variant="contained"
                        sx={{
                          minWidth: 100,
                          m: 1,
                          fontFamily: "THSarabunNew",
                          fontWeight: "bold",
                          fontSize: 15,
                        }}
                        onClick={handleClickOpensss}
                      >
                        อัพโหลดไฟล์ excel
                      </ColorButton>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "20px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        2.2 สร้างโฟร์เดอร์สำหรับอัพโหลดรูป
                      </Typography>
                      <ColorButton
                        variant="contained"
                        sx={{
                          minWidth: 100,
                          m: 1,
                          fontFamily: "THSarabunNew",
                          fontWeight: "bold",
                          fontSize: 15,
                        }}
                        onClick={handleClickOpenss}
                      >
                        สร้างโฟลเดอร์
                      </ColorButton>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "40px" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        2.2.1 ให้ จนท.ที่เกี่ยวข้องเข้าไปใน โฟลเดอร์ Server
                        แล้วเข้าไปใน โฟลเดอร์ pictureStu {"-->"} หลักสูตร{" "}
                        {"-->"} วางรูปไว้ในโฟลเดอร์เลขรุ่นที่สร้างไว้
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        id="modal-modal-title"
                        sx={{ marginLeft: "20px", color: "red" }}
                        variant="subtitle1"
                        component="h2"
                      >
                        (ตัวอย่างการตั้งชื่อไฟล์รูป เลขประจำตัวข้าราชการ.png
                        เช่น 1234567890.png หรือ 1234567890.jpg)
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Modal>
              {/* formstudent */}
              <Dialog
                open={opens}
                onClose={handleCloses}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <TextField
                    id="outlined-basic"
                    onChange={fileSelected}
                    label="import-excel"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    type={"file"}
                  />
                </DialogContent>
                <DialogActions>
                  <Button variant="contained" onClick={() => submit()}>
                    ตกลง
                  </Button>

                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleCloses}
                    autoFocus
                  >
                    ยกเลิก
                  </Button>
                </DialogActions>
              </Dialog>
              {/* formstudentforeign */}
              <Dialog
                open={opensss}
                onClose={handleClosesss}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <TextField
                    id="outlined-basic"
                    onChange={fileSelectedforeign}
                    label="import-excel-foreign"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    type={"file"}
                  />
                </DialogContent>
                <DialogActions>
                  <Button variant="contained" onClick={() => submitforeign()}>
                    ตกลง
                  </Button>

                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClosesss}
                    autoFocus
                  >
                    ยกเลิก
                  </Button>
                </DialogActions>
              </Dialog>
              {/* สร้างโฟร์เดอร์ */}
              <Dialog
                open={openss}
                onClose={handleClosess}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogContent>
                  <TextField
                    sx={{ width: "500px" }}
                    type="number"
                    InputProps={{
                      inputProps: {
                        max: 100,
                        min: 1,
                      },
                    }}
                    id="outlined-basic"
                    label="ใส่เลขรุ่นเพื่อสร้างโฟลเดอร์"
                    variant="outlined"
                    onChange={(e) => setFolderName(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button variant="contained" onClick={handleCreateFolder}>
                    ตกลง
                  </Button>

                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleClosess}
                    autoFocus
                  >
                    ยกเลิก
                  </Button>
                </DialogActions>
              </Dialog>
              <div style={{ height: 700, width: "100%" }}>
                <DataGrid
                  getRowId={(row) => row.PerId}
                  rows={getUserstu}
                  columns={columns1}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                />
              </div>
              <br></br>
              <center>
                <p>
                  **การให้สิทธิ์ของ นทน. ต้องสมัครสมาชิกสำหรับ นทน.
                  และสามารถอนุมัติสิทธิ์ได้ใน จัดการการเข้าถึงสิทธิ์ นทน.**
                </p>
              </center>
            </Container>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div className="cotainerDetail">
          <b>
            <p className="HeadTextMain">จัดการสมาชิก</p>
          </b>

          <div>
            <Button
              variant="outlined"
              sx={{
                minWidth: 100,
                m: 1,
                fontFamily: "THSarabunNew",
                fontWeight: "bold",
                fontSize: 15,
              }}
              onClick={Btncheckedtableinstructor}
            >
              คลิกเพื่อจัดการการเข้าถึงสิทธิ์เจ้าหน้าที่
            </Button>

            <Button
              variant="outlined"
              sx={{
                minWidth: 100,
                m: 1,
                fontFamily: "THSarabunNew",
                fontWeight: "bold",
                fontSize: 15,
              }}
              onClick={BtncheckedtableStudent}
            >
              คลิกเพื่อจัดการการเข้าถึงสิทธิ์ นทน.
            </Button>
          </div>

          {checkedtableinstructor === true ? (
            <Container>
              <br></br>
              <center>
                <p className="HeadTextMain">
                  จัดการการเข้าถึงสิทธิ์เจ้าหน้าที่
                </p>
              </center>
              <div style={{ height: 700, width: "100%" }}>
                <DataGrid
                  getRowId={(row) => row.PerId}
                  rows={getUser}
                  columns={columns2}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                />
              </div>
              <br></br>
              <center>
                <p>
                  **การให้สิทธิ์ของ นทน. ต้องสมัครสมาชิกสำหรับ นทน.
                  และสามารถอนุมัติสิทธิ์ได้ใน จัดการการเข้าถึงสิทธิ์ นทน.**
                </p>
              </center>
            </Container>
          ) : (
            ""
          )}

          {checkedtableStudent === true ? (
            <Container>
              <br></br>
              <center>
                <p className="HeadTextMain">จัดการการเข้าถึงสิทธิ์ นทน.</p>
              </center>
              <div style={{ height: 700, width: "100%" }}>
                <DataGrid
                  getRowId={(row) => row.PerId}
                  rows={getUserstu}
                  columns={columns3}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                />
              </div>
              <br></br>
              <center>
                <p>
                  **การให้สิทธิ์ของ นทน. ต้องสมัครสมาชิกสำหรับ นทน.
                  และสามารถอนุมัติสิทธิ์ได้ใน จัดการการเข้าถึงสิทธิ์ นทน.**
                </p>
              </center>
            </Container>
          ) : (
            ""
          )}
        </div>
      )}
    </React.Fragment>
  );
}
